module.exports = __webpack_public_path__ + "images/next/ja/icon_mobile-3a0b0a146e522066a424b04c3c1772b8.png";